/* Preserve the chosen base/size during art discovery without changing the cart. */
(function (root) {
  'use strict';
  function artUrl(href, context, origin) {
    const url = new URL(href, origin);
    if (url.origin !== origin || !/\/collections\/build-bundle\/?$/.test(url.pathname) || !context?.handle) return href;
    url.searchParams.set('base', context.handle);
    url.searchParams.delete('base_variant');
    url.searchParams.delete('base_size');
    if (/^\d+$/.test(String(context.variant || ''))) {
      url.searchParams.set('base_variant', context.variant);
      if (context.size && context.size !== 'Default Title') url.searchParams.set('base_size', context.size);
    }
    return url.pathname + url.search + url.hash;
  }
  function baseUrl(href, currentHref, origin) {
    const url = new URL(href, origin);
    const current = new URL(currentHref, origin);
    const handle = url.pathname.split('/products/')[1]?.replace(/\/$/, '');
    if (url.origin === origin && handle && handle === current.searchParams.get('base')) {
      const variant = current.searchParams.get('base_variant');
      if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
    }
    const preview = current.searchParams.get('preview_theme_id');
    if (preview && url.origin === origin) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search + url.hash;
  }
  function explicitBaseIndex(bases, href) {
    try {
      const handle = new URL(href).searchParams.get('base');
      return handle ? bases.findIndex(base => base.handle === handle) : -1;
    } catch (_) { return -1; }
  }
  function hasExplicitBasePreview(bases, href) { return explicitBaseIndex(bases, href) >= 0; }
  root.swapwearBaseHandoff = { artUrl, baseUrl, hasExplicitBasePreview, explicitBaseIndex };
  if (typeof module !== 'undefined') module.exports = { artUrl, baseUrl, hasExplicitBasePreview, explicitBaseIndex };
  if (!root.document) return;
  const doc = root.document;
  function context() {
    const main = doc.querySelector('[data-pdp-base-context]');
    if (!main || main.getAttribute('aria-busy') === 'true') return null;
    return { handle: main.dataset.productHandle, variant: main.dataset.pdpVariant, size: main.dataset.pdpSize };
  }
  function refreshLink(link) {
    const selection = context();
    if (!link || !selection) return;
    try { link.setAttribute('href', artUrl(link.href, selection, root.location.origin)); } catch (_) { /* Non-URL links are left alone. */ }
  }
  function refreshAll() { doc.querySelectorAll('a[href*="/collections/build-bundle"]').forEach(refreshLink); }
  ['pointerdown', 'focusin', 'contextmenu', 'click'].forEach(type => doc.addEventListener(type, event => refreshLink(event.target.closest?.('a[href]')), true));
  doc.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  doc.addEventListener('swapwear:pdp-selection', refreshAll);
  if (doc.readyState !== 'loading') refreshAll();
})(typeof window !== 'undefined' ? window : globalThis);
